import type { MigrationTaskProgressUpdate } from '@schema';

export interface MappedProgressUpdate {
  id: string;
  index: number;
  message: string;
  createdAt: string;
  /** Present for disk replication task progress (percent 0–100). */
  progress?: number | null;
}

export const mapProgressUpdates = (updates: MigrationTaskProgressUpdate[] | undefined): MappedProgressUpdate[] => (updates ?? [])
  .slice()
  .sort((a, b) => (a.index ?? 0) - (b.index ?? 0))
  .map(p => ({
    id: p.id ?? '',
    index: p.index ?? 0,
    message: p.message ?? '',
    createdAt: p.created_at ?? '',
    progress: p.progress ?? null
  }));

export type { MigrationTaskProgressUpdate };
